import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";
import useUser from "~/contexts/user";
import { SettingsSection } from "~/pages/manifold-nextgen/components/settings/SettingsSection";
import { getAvatarInitials } from "~/utils/strings";
import { ProfileGroupsSection } from "./ProfileGroupsSection";

/**
 * The profile's Account tab: who the user is, and which groups place them in the
 * organization. Read-only — identity comes from the identity provider and
 * membership from Access Controller, not from this form.
 */
export const ProfileAccountTab = () => {
  const user = useUser();

  const displayName = user?.name ?? user?.email ?? "";
  const initials = displayName ? getAvatarInitials(displayName) : "";

  return (
    <div className="mx-auto flex max-w-3xl flex-col gap-6">
      <SettingsSection title="Personal information">
        <div className="flex items-center gap-4 px-4 py-4">
          <Avatar className="size-[56px] shrink-0">
            <AvatarImage src={user?.picture} alt={displayName} />
            <AvatarFallback className="text-lg">{initials}</AvatarFallback>
          </Avatar>
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-foreground">{displayName}</p>
            <p className="truncate text-xs text-muted-foreground">{user?.email ?? ""}</p>
          </div>
        </div>
      </SettingsSection>

      <ProfileGroupsSection />
    </div>
  );
};
